export const clientConstants = {
  CLIENT_REMOVE_USER_ONLINE: 'CLIENT_REMOVE_USER_ONLINE',
  CLIENT_ADD_USER_ONLINE: 'CLIENT_ADD_USER_ONLINE',
  CLIENT_SET_USERS_ONLINE: 'CLIENT_SET_USERS_ONLINE',
  SET_SERVICES: 'CLIENT_SET_SERVICES',
  SET_ACCOUNT: 'CLIENT_SET_ACCOUNT'
}